import configsModule from "../../src/utils/prismicRepositoryConfigs"

/**
 * Prismic preview configuration for each repository in the app. This is shared
 * with the client-side utilities under `src/utils/prismicRepositoryConfigs` so
 * there is a single source of truth for link and component resolvers.
 */
const resolvedConfigs =
  configsModule?.repositoryConfigs || configsModule?.default || configsModule

export const repositoryConfigs = resolvedConfigs

export default repositoryConfigs
